export const calendarDaysBetween = (date1, date2) => {
  const msPerDay = 24 * 60 * 60 * 1000;

  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  return Math.round((utc2 - utc1) / msPerDay);
}